// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__ilZJU","title":"title__gevrt","right":"right__wsVej"};